import { render, staticRenderFns } from "./BtnSearch.vue?vue&type=template&id=95a72922&scoped=true"
import script from "./BtnSearch.vue?vue&type=script&lang=js"
export * from "./BtnSearch.vue?vue&type=script&lang=js"
import style0 from "./BtnSearch.vue?vue&type=style&index=0&id=95a72922&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95a72922",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
